import { Typography } from '@mui/material';


function Privacy(){
	
	return (
    <div className='container' style={{ padding: "64px 1vw 64px 3vw" }}>
      <Typography variant="h4" component="h4" mb={4}>
      Privacy Policy
      </Typography>
      
									<p>This privacy policy sets out how miwatchfaces.com uses and protects any
									information that you give us when you use this website.<br />
									 miwatchfaces.com is committed to ensuring that your privacy is
									protected. Should we ask you to provide certain information by which
									you can be identified when using this website, then you can be
									assured that it will only be used in accordance with this privacy
									statement.<br /> miwatchfaces.com may change this policy from
									time to time by updating this page. You should check this page from
									time to time to ensure that you are happy with any changes.
									</p>
									<br />
									<h3>What we collect</h3>
									<p>We may collect the following information:</p>
									<ul>
									<li>site user name</li>
									<li>email address</li>
									
									</ul>
									<h3>What we do with the information we gather</h3>
									<p>We require this information
									to provide you with a better service, and in particular for the
									following reasons:</p>
									<ul>
									<br />
									<li>We will use your email address to contact you regarding your question or issue with website.</li>
									<li>We will use your user name when showing site users content you've contributed.</li>
									<li>We will use data indicated in your profile when showing your profile and forum posts.</li>
									<li>We will never sell your information.</li>
									</ul>
									<br />
									<h3>Security</h3>
									<p>We are committed to ensuring that your information is secure.
									In order to prevent unauthorized access or disclosure we have put in
									place suitable physical, electronic and managerial procedures to
									safeguard and secure the information we collect online.</p>
									<br />
									<h3>How we use cookies</h3>
									<p>
									A cookie is a small file which asks permission to be placed on your
									computer's hard drive. Once you agree, the file is added and the
									cookie helps analyze web traffic or lets you know when you visit a
									particular site. Cookies allow web applications to respond to you as
									an individual. The web application can tailor its operations to your
									needs, likes and dislikes by gathering and remembering information
									about your preferences.&nbsp; <br /> We use traffic log
									cookies to identify which pages are being used. This helps us
									analyze data about web page traffic and improve our website in order
									to tailor it to customer needs.  <br /> Overall, cookies
									help us provide you with a better website, by enabling us to monitor
									which pages you find useful and which you do not. A cookie in no way
									gives us access to your computer or any information about you, other
									than the data you choose to share with us.&nbsp; <br /> You
									can choose to accept or decline cookies. Most web browsers
									automatically accept cookies, but you can usually modify your
									browser setting to decline cookies if you prefer. This may prevent
									you from taking full advantage of the website.
									</p>
									<br />
									<h3>Links to other websites</h3>
									<p>Our website may contain links to enable you to visit other
									websites of interest easily. However, once you have used these links
									to leave our site, you should note that we do not have any control
									over that other website. Therefore, we cannot be responsible for the
									protection and privacy of any information which you provide whilst
									visiting such sites and such sites are not governed by this privacy
									statement. You should exercise caution and look at the privacy
									statement applicable to the website in question.</p>
									<br />
									<h3>Controlling your personal information</h3>
									<p>
									We will not sell, distribute or lease your personal information to
									third parties unless we have your permission or are required by law.
									 <br /> You may request details of personal information
									which we hold about you under the Data Protection Act 1998. If you
									would like a copy of the information held on you please mail us at admin@miwatchfaces.com
									
									<br />
									
									If you believe that any information we are holding on you is
									incorrect or incomplete, please email us as soon as possible, at the
									above address. We will promptly correct any information found to be
									incorrect.
									</p>
									<br />
									<p><h3>Changes to This Privacy Policy</h3></p> <p> I may update our Privacy Policy from time to time. Thus, you are advised to review
                    this page periodically for any changes. I will notify you of any changes by posting
                    the new Privacy Policy on this page. These changes are effective immediately after they are posted on
                    this page.
					
                  </p> <br /><p><h3>Contact Us</h3></p> <p>If you have any questions or suggestions about my Privacy Policy, do not hesitate to contact
                    me.
                  </p>
      
    </div>
	);
}
export default Privacy